<template>
  <Breadcrumb></Breadcrumb>
  <PurchaseAgreementForm :purchaseAgreement="purchaseAgreement" :title="$gettext('Editer un compromis de vente')" @submit="onSubmit" @cancel="onCancel" />
</template>

<script setup>
import { usePurchaseAgreementStore } from "@/stores/purchaseAgreement";
import { useRouter, useRoute } from "vue-router";
import PurchaseAgreementForm from "@/components/purchase-agreements/PurchaseAgreementForm.vue";
import { ref, onMounted } from "vue";
import Breadcrumb from "@/components/layout/BreadcrumbNavigation.vue";

const router = useRouter();
const route = useRoute();
const saleListingAgreementId = route.query.saleListingAgreementId;
const purchaseOfferId = route.query.purchaseOfferId;
const purchaseAgreementStore = usePurchaseAgreementStore();
const purchaseAgreement = ref(null);

const onSubmit = (payload, actions) => {
  purchaseAgreementStore.save(payload, saleListingAgreementId, purchaseOfferId, () => {
    router.push({ name: "sale-listing-agreement", params: { id: saleListingAgreementId } });
  }, (errors) => {
    actions.setErrors(errors.value);
  });
};

const onCancel = () => {
  router.back();
};

onMounted(async () => {
  purchaseAgreement.value = await purchaseAgreementStore.fetchOne(router.currentRoute.value.params.id, saleListingAgreementId, purchaseOfferId);
});

</script>
